const dateFieldsForDramaturgyShortPlanning = [
  {
    key: "delivery",
    label: "ENTREGA PLANEJADO",
    startHiddenOnCreate: false,
  },
  {
    key: "contentAssessment",
    label: "PARECER CONTEÚDO PLANEJADO",
    startHiddenOnCreate: true,
  },
  {
    key: "productionAssessment",
    label: "PARECER PRODUÇÃO PLANEJADO",
    startHiddenOnCreate: true,
  },
  {
    key: "diversityAssessment",
    label: "PARECER DIVERSIDADE PLANEJADO",
    startHiddenOnCreate: true,
  },
  {
    key: "release",
    label: "LIBERAÇÃO PLANEJADO",
    startHiddenOnCreate: false,
  },
  {
    key: "channelNotes",
    label: "NOTES DO CANAL PLANEJADO",
    startHiddenOnCreate: true,
  },
];

const dateFieldsForDramaturgyLongPlanningPost = [
  { key: "delivery", label: "ENTREGA PLANEJADA", startHiddenOnCreate: false },
  { key: "release", label: "LIBERAÇÃO PLANEJADA", startHiddenOnCreate: false },
  {
    key: "contentAssessment",
    label: "PARECER CONTEÚDO PLANEJADO",
    startHiddenOnCreate: true,
  },
  {
    key: "diversityAssessment",
    label: "PARECER DIVERSIDADE PLANEJADO",
    startHiddenOnCreate: true,
  },
  {
    key: "channelNotes",
    label: "NOTES DO CANAL PLANEJADO",
    startHiddenOnCreate: true,
  },
];

const dateFieldsForAttachmentsEditDramaturgyShort = [
  {
    key: "realizedContentSight",
    label: "PARECER CONTEÚDO ANEXO",
    isDisabled: true,
  },
  { key: "realizedProdutionSight", label: "PARECER PRODUÇÃO ANEXO" },
  {
    key: "diversityAssessment",
    label: "PARECER DIVERSIDADE ANEXO",
    isDisabled: true,
  },
  { key: "realizedChannelFeedback", label: "NOTES DO CANAL ANEXO" },
];

const dateFieldsForAttachmentsEditDramaturgyLong = [
  {
    key: "realizedContentSight",
    label: "PARECER CONTEÚDO ANEXO",
    isDisabled: true,
  },
  {
    key: "diversityAssessment",
    label: "PARECER DIVERSIDADE ANEXO",
    isDisabled: true,
  },
  { key: "realizedChannelFeedback", label: "NOTES DO CANAL ANEXO" },
];

const dateFieldsForVarietiesPlanning = [
  ...dateFieldsForDramaturgyShortPlanning,
];

export const DATE_FIELDS = {
  dateFieldsForDramaturgyLongPlanningPost,
  dateFieldsForDramaturgyShortPlanning,
  dateFieldsForVarietiesPlanning,
  dateFieldsForAttachmentsEditDramaturgyShort,
  dateFieldsForAttachmentsEditDramaturgyLong,
};
